import { Image } from "~/components/image";
import iphoneMockup from "/data/images/iphone-mockup.png";

const sizes = "(min-width: 1040px) 448px, (min-width: 680px) 512px, 90vw";
const responsive = [
  {
    size: {
      width: 720,
    },
  },
  {
    size: {
      width: 640,
    },
  },
  {
    size: {
      width: 448,
    },
  },
  {
    size: {
      width: 320,
    },
  },
];

export const meta = () => {
  return [
    {
      title:
        "Takealot Seller App: Manage your online business on the go | Shopdeploy",
    },
    {
      name: "description",
      content:
        "Use the Shopdeploy Takealot Seller app to manage repricing, monitor the buy box, track sales, and more—all from your smartphone or tablet.",
    },
  ];
};

export default function TakealotSellerApp() {
  return (
    <div className="mt-10">
      <div className="relative overflow-hidden bg-white">
        <main className="mx-auto  max-w-7xl px-4  sm:px-6 ">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left m-auto">
              <span className="block text-base font-semibold text-gray-500 sm:text-lg lg:text-base xl:text-lg">
                Web App
              </span>
              <h1>
                <span className="mt-1 block text-4xl font-bold tracking-tight sm:text-5xl xl:text-6xl">
                  <span className="block text-gray-900">Takealot Seller</span>
                  <span className="block text-indigo-600">Mobile App</span>
                </span>
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                Manage your Takealot Seller Account from your mobile device.
                View your sales, check inventory levels and update your
                repricing.
              </p>
              <div className="mt-8 sm:mx-auto sm:max-w-lg sm:text-center lg:mx-0 lg:text-left">
                <div className="rounded-md shadow">
                  <a
                    href="https://app.shopdeploy.com/signup"
                    className="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 md:py-4 md:px-10 md:text-lg"
                  >
                    Get started for free!
                  </a>
                </div>
              </div>
            </div>
            <div className="relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center">
              <div className="relative mx-auto w-full  lg:max-w-md">
                <Image
                  src={iphoneMockup}
                  alt={"Shopdeploy iOS Mockup"}
                  responsive={responsive}
                  sizes={sizes}
                />
                {/* <StaticImage
                  src={"../images/pages/iphone-mockup.png"}
                  alt={"ipn"}
                /> */}
              </div>
            </div>
          </div>
        </main>
      </div>

      {/*<div className="bg-violet-50">*/}
      {/*    <div className="mx-auto  max-w-7xl px-4  sm:px-6 "> trtre</div>*/}
      {/*</div>*/}

      <div className="bg-indigo-700">
        <div className="mx-auto max-w-3xl py-16 px-2 text-center sm:py-20 sm:px-2 lg:px-1">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            <span className="block">
              Manage your Takealot Seller Account on the go!
            </span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-indigo-200">
            The Shopdeploy web app is packed with all the features your need to
            manage your Takealot Seller Account from your mobile device. To get
            started all you need is a Shopdeploy account and then follow the
            instructions below to add Shopdeploy to the Home Screen of your iOS
            or Android device.
          </p>
        </div>
      </div>

      <div className="bg-white">
        <div className="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
          <div className="lg:grid lg:grid-cols-3 lg:gap-8">
            <div>
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Instructions for iOS devices{" "}
              </h2>
              <p className="mt-4 text-lg text-gray-500">
                Follow these instructions to add Shopdeploy as a shortcut on
                your iOS device.
              </p>
            </div>
            <div className="mt-12 lg:col-span-2 lg:mt-0">
              <ol className="space-y-4 list-decimal ">
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Launch Safari app.
                </li>
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Enter `https://app.shopdeploy.com` into the address field. Tap
                  Go.
                </li>
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Tap the icon featuring an upwards-pointing arrow coming out of
                  a box to open a drop-down menu.
                </li>
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Tap Add to Home Screen. The "Add to Home" dialog box will
                  appear, with the icon that will be used for this website on
                  the left side of the dialog box.
                </li>
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Confirm the url is `https://app.shopdeploy.com`{" "}
                </li>
                <li className="text-lg font-normal leading-6 text-gray-900">
                  Tap Add and your will be taken to the location where the icon
                  is displayed in iOS
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
